import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children, initialPermissions }) => {
    const [userPermissions, setUserPermissions] = useState(initialPermissions || []);

    useEffect(() => {
        if (initialPermissions && initialPermissions.length > 0) {
            setUserPermissions(initialPermissions);
        }
    }, [initialPermissions]);

    return (
        <UserContext.Provider value={{ userPermissions, setUserPermissions }}>
            {children}
        </UserContext.Provider>
    );
};